/**
 * 수학머리 테스트(age) 세트의 level_value → 표시명 i18n 키.
 * level_value는 세트가 시작하는 나이다. '9' 세트는 9~10세, '11' 세트는 11세 이상이 대상이다(Asana 1219764372903274).
 * 키는 admin 네임스페이스 `diagnosticSets.*` 하위. 호출부가 네임스페이스 접두를 붙인다.
 */
export type AiqSetNameKey = 'ageSetName' | 'ageRangeSetName' | 'agePlusSetName'

export interface AiqSetName {
  key: AiqSetNameKey
  params: { age: number; toAge?: number }
}

const AGE_RANGE_END: Record<number, number> = { 9: 10 }
const AGE_PLUS = new Set([11])

export function aiqSetName(levelValue: string): AiqSetName | null {
  const trimmed = levelValue.trim()
  if (!/^\d+$/.test(trimmed)) return null
  const age = Number(trimmed)
  const toAge = AGE_RANGE_END[age]
  if (toAge != null) return { key: 'ageRangeSetName', params: { age, toAge } }
  if (AGE_PLUS.has(age)) return { key: 'agePlusSetName', params: { age } }
  return { key: 'ageSetName', params: { age } }
}
